import { CSSObject } from '@emotion/react'
import { AssetReference } from '@opallabs/cassini'
import { fonts, fontSizes, fontWeights } from '@opallabs/pulsar'
import getAssetOrientation from '../../../../helpers/functions/getAssetOrientation'
import { sharedColors } from '../../../sharedDisplays/sharedStyles/styles'

const getContentWrapper = (isMobile: boolean): CSSObject => ({
  margin: isMobile ? '0 16px 0 76px' : '0 16px 0 75px',
})

const linkAssetHeight: Record<string, string> = {
  mobileStream: '148px',
  desktopStream: '268px',
}

const getLinkAssetStyle = (hasAsset: boolean, display: string): CSSObject => ({
  border: sharedColors.border,
  borderRadius: display.includes('mobile') ? '10px 10px 0 0' : '14px 14px 0 0',
  height: hasAsset ? linkAssetHeight[display] : 0,
  width: display.includes('mobile') ? '283px' : '509px',
  img: {
    borderRadius: display.includes('mobile')
      ? '10px 10px 0 0'
      : '14px 14px 0 0',
    height: linkAssetHeight[display],
  },
})

const linkTitleStyle: CSSObject = {
  color: sharedColors.darkGreyText,
  fontFamily: fonts.helvetica,
  fontSize: fontSizes.large,
  fontWeight: fontWeights.medium,
  padding: '2.5px 5px',
}

const getLinkDescriptionStyle = (isMobile: boolean): CSSObject => ({
  color: isMobile ? sharedColors.darkGreyText : sharedColors.medGreyText,
  fontFamily: fonts.helvetica,
  fontSize: isMobile ? fontSizes.medium : fontSizes.large,
  padding: '2.5px 5px',
})

const getLinkDomainStyle = (isMobile: boolean): CSSObject => ({
  color: sharedColors.medGreyText,
  fontSize: isMobile ? fontSizes.medium : fontSizes.large,
  padding: '2.5px 5px',
  fontFamily: fonts.helvetica,
})

const linkBorders: Record<string, string> = {
  mobileStream: '10px',
  desktopStream: '14px',
}

const getLinkStyle = (hasAsset: boolean, display: string): CSSObject => ({
  border: sharedColors.border,
  borderRadius: hasAsset
    ? `0 0 ${linkBorders[display]} ${linkBorders[display]}`
    : `${linkBorders[display]}`,
  padding: display.includes('mobile') ? '5.5px 7px' : '6.5px 7px',
  '.kuiper-input-textarea .kuiper-input-container, kuiper-input-textarea.kuiper-filled kuiper-input-container':
    {
      backgroundColor: 'white',
    },
  '.kuiper-input.kuiper-filled .kuiper-input-container, .kuiper-input.kuiper-focused .kuiper-input-container':
    {
      backgroundColor: 'white',
    },
  '.kuiper-icon-wrapper .kuiper-icon-twitter-desktop-website-card-url': {
    color: sharedColors.medGreyText,
  },
})

const galleryDimensions: Record<string, CSSObject> = {
  mobileStream: {
    height: '160px',
    width: '283px',
    overflow: 'hidden',
  },
  desktopStream: {
    maxHeight: '287px',
    minHeight: '103px',
    width: '509px',
  },
}

const getGalleryContainer = (display: string): CSSObject => ({
  ...galleryDimensions[display],
  backgroundColor: sharedColors.border,
  borderRadius: display.includes('mobile') ? '10px' : '14px',
})

const getAssetStyles = (
  asset: AssetReference,
  isMobile: boolean
): { asset: CSSObject; assetBase: CSSObject } => {
  const orientation = getAssetOrientation(asset)
  const maxWidth = isMobile ? '283px' : '509px'
  const maxHeight = isMobile ? '282px' : '510px'
  return {
    assetBase: {
      borderRadius: isMobile ? '10px' : '14px',
      overflow: 'hidden',
      border: sharedColors.border,
      width: 'fit-content',
    },
    asset: {
      width: orientation === 'portrait' ? 'auto' : maxWidth,
      height: orientation === 'landscape' ? 'auto' : maxHeight,
      maxWidth: orientation === 'portrait' ? maxWidth : '',
      img: {
        width: orientation !== 'portrait' ? maxWidth : '',
        height: orientation !== 'landscape' ? maxHeight : '',
        marginBottom: '-2px',
      },
    },
  }
}

const styles = {
  getContentWrapper,
  linkTitleStyle,
  getGalleryContainer,
  getAssetStyles,
  getLinkAssetStyle,
  getLinkStyle,
  getLinkDescriptionStyle,
  getLinkDomainStyle,
}

export { styles }
